import styled from 'styled-components';
import { Button } from '@comeon/ui';
import useTranslations from '~/components/translation/use-translations.ts';
import useGuestLogin from '~/components/guest-login/hooks/use-guest-login';

const StyledPlayAsGuestButton = styled(Button)`
	background-color: var(--button-pag, rgba(var(--base-08), 1));
	color: var(--button-pag-text, rgba(var(--font-light), 1));
	border: var(--button-play-as-guest-border, var(--filter-border-primary));
	padding: ${props => props.small && '9px 15px'};
`;

const TEXT_KEYS = ['MOBILE_PAG_LOGIN'];

const PlayAsGuestButton = ({ dataAt, small = false, className }) => {
	const { redirectToPlayAsGuest } = useGuestLogin();
	const { translations: tr, isLoadingTranslations } = useTranslations(TEXT_KEYS);

	if (isLoadingTranslations) {
		return null;
	}
	return (
		<StyledPlayAsGuestButton dataAt={dataAt} small={small} onClick={redirectToPlayAsGuest} className={className}>
			{tr.MOBILE_PAG_LOGIN}
		</StyledPlayAsGuestButton>
	);
};

export default PlayAsGuestButton;
